import { UNSTYLED } from '../../types/BlockTypes';
export default function resetBlocks(editor, blocks) {
  blocks.forEach(function (block) {
    return editor.setNodeByKey(block.key, {
      type: UNSTYLED,
      data: undefined
    });
  });
  return editor;
}